module.exports = __webpack_public_path__ + "img/dashboard-add-xome.95da935f.png";